import { createAutocompleteController } from "./createAutocompleteController"
import { useGrupoAtivosCorporateIF } from "./useGrupoAtivosCorporateIF"

export const useGrupoAtivosCorporateIFAutocompleteController = createAutocompleteController(useGrupoAtivosCorporateIF)
